import { deleteOffer, patchPublishCourse, patchPublishTest, patchPublishOffers, patchPublishStudyMaterials, patchPublishVideoResource, storeSpecificCourseData, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification, getAutocompleteSearchForNotification, sendCourseNotification, getCourseDashboardData } from 'actions/courseManagement';
import { Modal, Select, Switch, Checkbox, Row, Col } from 'antd'
import { Button } from 'components/Button';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import confirmIllustration from "../../Assets/common/confirmIllustration.svg";
import Xmark from "../../Assets/common/Xmark.svg";
import downArrow from "../../Assets/common/downArrow.svg";
import { CheckOutlined, SearchOutlined } from '@ant-design/icons';
import { fetchClassList } from 'actions/schedule';

function SendNotificationMOdal({
    courseTypeName,
    sendCourseNotification,
    isConfirmPublishModalVisible,
    setIsConfirmPublishModalVisible,
    getCoursesCategoriesForNotifications,
    getCoursesSubCategoriesForNotification, autocompleteSearchData, fetchClassList, classList,courseDashboardData,
    courseCategoryData, courseSubCategoriesData, getAutocompleteSearchForNotification, specificCourseDataContainer,getCourseDashboardData
}) {
    const handleCancel = () => {
        setIsConfirmPublishModalVisible(false)
    }
    const [btnLoader, setBtnLoader] = useState(false);
    const [isEnabled, setIsEnabled] = useState(true);
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [updatedClassList, setUpdatedClassList] = useState([]);
    const [type, setType] = useState('allStudents');
    let showPublish = true;

    const options = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { label: "Classroom courses", value: "course" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { label: "Video resources", value: "videoResource" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { label: "Online test series", value: "testSeries" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") &&  { label: "Study materials", value: "studyMaterial" },
        
    ].filter(Boolean);

    const handleChange = (checkedValues) => {
        setCheckedItems(checkedValues);
    };
    useEffect(() => {
        getCoursesCategoriesForNotifications()
        getCoursesSubCategoriesForNotification()
        getAutocompleteSearchForNotification(null, () => { })
        fetchClassList('', null)
        getCourseDashboardData(()=>{})
    }, [])

    useEffect(() => {
        setUpdatedClassList(classList.map(({ section,std, ...rest }) => ({
            ...rest,
            name: `${std} - ${section}` // Rename 'section' to 'name'
        })))
    }, [])

    const handleChangeCategories = (value) => {
        const selectedCourse = courseCategoryData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeSubCategories = (value) => {
        const selectedCourse = courseSubCategoriesData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedSubCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedSubCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeCourses = (value) => {
        const selectedCourse = autocompleteSearchData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCourses.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCourses(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleChangeBatches = (value) => {
        const selectedCourse = updatedClassList.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedBatches.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedBatches(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleRemoveCategory = (courseId) => {
        setSelectedCategory(selectedCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveSubCategory = (courseId) => {
        setSelectedSubCategory(selectedSubCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveCourses = (courseId) => {
        setSelectedCourses(selectedCourses.filter(course => course.id !== courseId));
    };
    const handleRemoveBatches = (courseId) => {
        setSelectedBatches(selectedBatches.filter(course => course.id !== courseId));
    };

    const isDisabled = showPublish && !(
        type === 'allStudents' ||
        (type === 'course' && selectedCourses.length > 0) ||
        (type === 'batch' && selectedBatches.length > 0) ||
        (type === 'courseType' && checkedItems.length > 0) ||
        (type === 'courseCategory' && selectedCategory.length > 0) ||
        (type === 'courseSubcategory' && selectedSubCategory.length > 0)
    );

  
    return (
        <Modal
            centered
            className="modal-round-corner"
            visible={isConfirmPublishModalVisible}
            onCancel={handleCancel}
            onOk={handleCancel}
            footer={null}
            closable={false}>


            <div style={{ display: 'flex', justifyContent: 'flex-end', }} ><img style={{ cursor: 'pointer' }} src={Xmark} onClick={() => { handleCancel() }} /></div>
            <div style={{ fontSize: "20px", color: "#191919", display: "flex", justifyContent: "center", fontFamily: "Roboto, sans-serif", }}>Send push notification!</div>
            <center style={{ color: "#636363", fontSize: 16, marginTop: 5, padding: "0px 20px", fontFamily: "Roboto, sans-serif", }}> Push notification will be sent to the selected targets</center>

            {
                showPublish && isEnabled &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px', fontWeight: 400 }}>Send push notifications to <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            // placeholder="Select plan"
                            value={type}
                            onChange={(e) => {
                                setType(e)
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                        >
                            <Option value="allStudents">All students</Option>
                            <Option value="batch">Batch</Option>
                            <Option value="course">Course</Option>
                            <Option value="courseType">Course type</Option>
                            <Option value="courseCategory">Course category</Option>
                            <Option value="courseSubcategory">Course subcategory</Option>
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                </div>
            }

            {
                showPublish && isEnabled && type === 'courseType' && (
                    <div style={{ marginLeft: 20, marginTop: 20}}>
                        <Checkbox.Group value={checkedItems} onChange={handleChange}>
                            <Row gutter={[20, 10]} style={{ fontFamily: "Roboto, sans-serif" }}>
                                {options.map((option) => (
                                    <Col key={option.value} xs={24} sm={12} md={12}> {/* 2 items per row */}
                                        <Checkbox
                                            value={option.value}
                                            style={{
                                                color: "#636363",
                                                fontSize: 16,
                                                width:200
                                            }}
                                        >
                                            {option.label}
                                        </Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </Checkbox.Group>
                    </div>
                )
            }

            {
                showPublish && isEnabled && type == 'courseCategory' &&

                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course categories <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: Marketing, Cloud computing etc.
                                </span>
                            }
                            onChange={(value) => {
                              
                                handleChangeCategories(value);
                            }}
                            style={{ width: '98%', }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching category found"
                        >
                            {courseCategoryData.map((course) => {
                                const isSelected = selectedCategory.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                            
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedCategory.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveCategory(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'courseSubcategory' &&

                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course subcategory <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: Marketing, Cloud computing etc.
                                </span>
                            }

                            onChange={(value) => {
                               
                                handleChangeSubCategories(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching subcategoryy found"
                        >
                            {courseSubCategoriesData.map((course) => {
                                const isSelected = selectedSubCategory.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                           
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedSubCategory.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveSubCategory(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'course' &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select course name <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: JEE main 2025 etc.
                                </span>
                            }

                            onChange={(value) => {
                              
                                handleChangeCourses(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching course found"
                        >
                            {autocompleteSearchData.map((course) => {
                                const isSelected = selectedCourses.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                            
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedCourses.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveCourses(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }

            {
                showPublish && isEnabled && type == 'batch' &&
                <div style={{ marginTop: 20 }}>
                    <div style={{ color: '#aeaeae', fontSize: 10, padding: '0px 20px' }}>Select batch <span style={{ color: '#ff414d' }}>*</span></div>
                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                        <Select
                            bordered={null}
                            showSearch={true}
                            placeholder={
                                <span style={{marginLeft:-10, position:'absolute', zIndex:1}}>
                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                    Sample: JEE batch 2025 etc.
                                </span>
                            }

                            onChange={(value) => {
                              
                                handleChangeBatches(value);
                            }}
                            style={{ width: '98%' }}
                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                            value={null}
                            filterOption={(input, option) => {
                                // Case-insensitive search
                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }}
                            // Optional: customize the no-match message
                            notFoundContent="No matching batch found"
                        >
                            {updatedClassList.map((course) => {
                                const isSelected = selectedBatches.some(selected => selected.id === course.id);
                                return (
                                    <Option
                                        key={course.id}
                                        value={course.id}
                                        style={{
                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                            fontWeight: isSelected ? '500' : 'normal',
                                            borderRadius: 5,
                                            
                                        }}
                                    >
                                        {course.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </div>
                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                    <div className="selected-courses">
                        {selectedBatches.map((course) => (
                            <div key={course.id} className="course-tag">
                                {course.name}
                                <span
                                    className="remove-icon"
                                    onClick={() => handleRemoveBatches(course.id)}
                                >
                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            }
            <center>
                <div style={{ display: "flex", justifyContent: "center", marginTop: 60 }}>
                    <Button disabled={isDisabled} /* loading={btnLoader} */ type='primary'
                        onClick={() => {
                            const params = {
                                resourceItems: courseTypeName == 'onlineTestSeries' ?
                                    [{ id: specificCourseDataContainer?.testSeriesDetails?.id, resourceType: 'testSeries' }] :
                                    courseTypeName == 'liveCourses' ?
                                    [{ id: specificCourseDataContainer?.course?.id, resourceType: 'course' }] :
                                    courseTypeName == 'videoResources' ?
                                    [{ id: specificCourseDataContainer?.id, resourceType: 'videoResource' }] :
                                    [{ id: specificCourseDataContainer?.id, resourceType: 'studyMaterial' }],
                                standardIds: type == 'batch' ? selectedBatches?.map(item => item.id) : [],
                                categoryIds: type == 'courseCategory' ? selectedCategory?.map(item => item.id) : [],
                                subcategoryIds: type == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [],
                                courseItems: type == 'course' ? selectedCourses?.map(item => ({
                                    id: item.itemId,
                                    resourceType: item.itemType
                                })) : [],
                                courseTypes:type == 'courseType' ? checkedItems : [],
                            }
                            setBtnLoader(true);
                            sendCourseNotification(
                                params,
                                () => {  },
                                () => {
                                    handleCancel();
                                    setBtnLoader(false);
                                    // togglePageLoader(true);
                                    // getSearchResultsData(() => { togglePageLoader(false) })
                                }
                            )
                        }}>SEND NOTIFICATION</Button>
                </div>
               
            </center>
        </Modal>
    )
}
const mapStateToProps = (state) => {
    const { courseCategoryData, courseSubCategoriesData, autocompleteSearchData,courseDashboardData } = state.courseManagement
    const { classList } = state.schedule
    return {
        courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,courseDashboardData
    };
};

const mapDispatchToProps = (dispatch) => ({
    patchPublishCourse: (ids, publish, callBack, successCallBack) => dispatch(patchPublishCourse(ids, publish, callBack, successCallBack)),
    patchPublishTest: (ids, publish, callBack, successCallBack) => dispatch(patchPublishTest(ids, publish, callBack, successCallBack)),
    sendCourseNotification: (params, callBack, successCallBack) => dispatch(sendCourseNotification(params, callBack, successCallBack)),
    patchPublishStudyMaterials: (ids, publish, callBack, successCallBack) => dispatch(patchPublishStudyMaterials(ids, publish, callBack, successCallBack)),
    patchPublishVideoResource: (ids, isPublish, callBack, successCallBack) => dispatch(patchPublishVideoResource(ids, isPublish, callBack, successCallBack)),
    deleteOffer: (id, callBack, successCallBack) => dispatch(deleteOffer(id, callBack, successCallBack)),
    patchPublishOffers: (id, publish, callBack, successCallBack) => dispatch(patchPublishOffers(id, publish, callBack, successCallBack)),
    storeSpecificCourseData: (val) => dispatch(storeSpecificCourseData(val)),
    getCoursesCategoriesForNotifications: () => dispatch(getCoursesCategoriesForNotifications()),
    getCoursesSubCategoriesForNotification: () => dispatch(getCoursesSubCategoriesForNotification()),
    getAutocompleteSearchForNotification: (search, callBack) => dispatch(getAutocompleteSearchForNotification(search, callBack)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    getCourseDashboardData: (callBack) => dispatch(getCourseDashboardData(callBack)),

});
export default connect(mapStateToProps, mapDispatchToProps)(SendNotificationMOdal);